import { IAbstractTimeSeriesIncludeBuilder } from "./IAbstractTimeSeriesIncludeBuilder.js";

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface ISubscriptionTimeSeriesIncludeBuilder<TBuilder> extends IAbstractTimeSeriesIncludeBuilder<TBuilder> {

}
